module.exports = __webpack_public_path__ + "img/seifendispenser.78f0dd1.png";